import { merge } from 'lodash';

import { api } from '@shared/api/api';

type TimeTrackingEntry = App.Domain.TimeTracking.Data.TimeTrackingEntryData;

export const getTimeTrackingEntries = api.createIndex<TimeTrackingEntry>('time-tracking-entries');
